/* eslint-disable */
import { 
    greenThemeDark
} from '../theme/theme'


export const themeData = {
    theme: greenThemeDark
}
